import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-forest flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="h-14 w-14 mx-auto rounded-2xl bg-brand-terracotta flex items-center justify-center mb-4">
            <Lock className="text-white" size={26} />
          </div>
          <h1 className="font-display text-4xl tracking-tight text-brand-bg">Host Login</h1>
          <p className="text-brand-bg/60 mt-2">Manage your guidebook content</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-3xl p-8 shadow-xl space-y-5" data-testid="login-form">
          <div>
            <Label className="mb-1.5 block">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" placeholder="you@email.com" />
          </div>
          <div>
            <Label className="mb-1.5 block">Password</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-12 rounded-full bg-brand-forest hover:bg-brand-terracotta text-white active:scale-95 transition-colors">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
          <button type="button" onClick={() => navigate("/")} className="w-full text-sm text-brand-forest/50 hover:text-brand-terracotta transition-colors">
            ← Back to guidebook
          </button>
        </form>
      </div>
    </div>
  );
}
